import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
// import { createLogger } from 'redux-logger'
import rootReducer from '../modules'

// eslint-disable-next-line
export default (initialState = {}) => {
  const middlewares = [thunk]

  //redux log
  // if (process.env.NODE_ENV !== 'production') middlewares.push(createLogger())

  const store = createStore(rootReducer, initialState, applyMiddleware(...middlewares))

  return store
}
